import { SymbolEventColumn } from 'widgets/corpActions/widget/grid/columnDefinitions';
import { GridDetailsPanelColumnDef } from 'utils/components/GridDetailsPanel/gridDetailsPanelColumnDef';

const stockSplit: GridDetailsPanelColumnDef<SymbolEventColumn>[] = [
    {
        controls: [
            { type: 'field', field: 'recordDate' },
            { type: 'field', field: 'adjustmentFactor' },
            { type: 'field', field: 'ccTerms' },
            { type: 'field', field: 'exDate' },
        ],
    },
    {
        controls: [
            { type: 'field', field: 'exDate' },
            { type: 'field', field: 'payDate' },
            { type: 'field', field: 'ccRatio' },
            { type: 'field', field: 'capitalChangeType' },
        ],
    },
];

export default stockSplit;
